import { BASE_URL } from "../configs";
import { getAccessToken } from "../helpers/auth/token";
import { getQueryParamsString } from "../lib/utils";
import axiosInstance from './axios'

export async function getEquipmentPreCheckQxn({
  equipmentId,
  page,
  perPage,
}) {
  let url = `${BASE_URL}/api/equipment-precheck-qxn-set?`;
  url += getQueryParamsString({ equipmentId, page, perPage })

  const res = await axiosInstance.get(url)
  return res.data.Data;
}

export async function createEquipmentPreCheckQxn(equipmentQxnSet) {
  let url = `${BASE_URL}/api/equipment-precheck-qxn-set`;

  const res = await axiosInstance.post(url, equipmentQxnSet)
  return res.data.Data;
}

export async function updateEquipmentPreCheckQxn(equipmentQxnSet) {
  let url = `${BASE_URL}/api/equipment-precheck-qxn-set`;

  const res = await axiosInstance.put(url, equipmentQxnSet)
  return res.data.Data;
}

export async function deleteEquipmentPreCheckQxn(qxnSetId) {
  let url = `${BASE_URL}/api/equipment-precheck-qxn-set/${qxnSetId}`;

  const res = await axiosInstance.delete(url)
  return res.data.Data;
}
